import { reduxBatch } from '@manaflair/redux-batch';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { reduxApi } from '../../services/api';
import { reducers } from './root';

export const store = configureStore({
  reducer: {
    ...reducers,
    [reduxApi.reducerPath]: reduxApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(reduxApi.middleware),
  enhancers: [reduxBatch],
});

setupListeners(store.dispatch);
